const initAccordionLists = () => {
    document.querySelectorAll('.accordion-list__items').forEach((list) => {
        const items = list.querySelectorAll('.accordion-list__item');

        if (!items.length) {
            return;
        }

        if (!list.querySelector('.accordion-list__item[open]')) {
            items[0].open = true;
        }

        items.forEach((item) => {
            const header = item.querySelector('.accordion-list__header');

            if (!header) {
                return;
            }

            header.addEventListener('click', (event) => {
                event.preventDefault();

                item.open = !item.open;
            });
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionLists);
} else {
    initAccordionLists();
}
